function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function identifyEvent() {
  console.log('identifyEvent');
  
  const fbcCookie = getCookie('_fbc');
  const fbpCookie = getCookie('_fbp');
  
  analytics.identify({
    fbc: fbcCookie,
    fbp: fbpCookie,
  });
}